export default "__VITE_ASSET__3628fbec__"